<template lang="pug">
  .container
    include Blog.pug
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Blog',
  props: ['category'],
  head: {
    title: {
      inner: 'Blog',
    },
  },
  computed: mapState([
    "context",
  ]),
  data() {
    return {
      selectVisible: false,
      entries: [],
    }
  },
  created() {
    const _this = this
    let category = this.category ? this.category : null

    this.$wagtail.getEntries(category).then((response) => {
      let data = response.data
      _this.entries = data.results
    })
  },
  methods: {
    showCategories() {
      this.selectVisible = !this.selectVisible
    },
  },
}
</script>

<style scoped lang="scss">
@import './../../variables';
@import './../../variables_colreps';

@import 'Post';

.context-colreps {
  @import 'PostColreps';
}
</style>



// WEBPACK FOOTER //
// src/components/blog/Blog.vue